import http from '@/http';
import router from '@/router';

const types = {
    AUTH_SET_TOKEN: 'AUTH_SET_TOKEN',
    AUTH_SET_USER: 'AUTH_SET_USER',
    AUTH_REMOVE_TOKEN: 'AUTH_REMOVE_TOKEN',
};

export const state = {
    token: null,
    user: null,
};

export const getters = {
    isAuthenticated: ({ token }) => token !== null,
};

export const mutations = {
    [types.AUTH_SET_TOKEN](state, token) {
        state.token = token;
    },
    [types.AUTH_REMOVE_TOKEN](state) {
        state.token = null;
        state.user = null;
    },
    [types.AUTH_SET_USER](state, user) {
        state.user = user;
    },
};

export const actions = {
    authenticate({ commit }, fields) {
        return http.post('auth/login', fields)
            .then(({ access_token }) => {
                commit(types.AUTH_SET_TOKEN, access_token);

                return access_token;
            });
    },
    removeToken({ commit }) {
        commit(types.AUTH_REMOVE_TOKEN);
    },
    logout({ commit }) {
        return http.post('auth/logout').finally(data => {
            commit(types.AUTH_REMOVE_TOKEN);

            router.push({ name: 'login' });

            return data;
        });
    },
};